import React, { useMemo } from 'react'
import { Trans } from 'react-i18next'

import { Screen24 } from '@makyoapp/makyo-icon/icon'
import { SelectDropdown } from '@makyoapp/makyo-ui'

import { useAppBuilderContext } from '@/context/AppBuilderContext'

export function PageSelectV2({
  id,
  value,
  onChange,
  excludes = [],
  portal = true,
}: {
  id?: string
  value?: string
  onChange: (value: string) => void
  excludes?: string[]
  portal?: boolean
}) {
  const { pages } = useAppBuilderContext()

  const options = useMemo(() => {
    return excludes.length > 0 ? pages.filter(({ id }) => !excludes.includes(id)) : pages
  }, [pages, excludes])

  return (
    <SelectDropdown
      id={id}
      value={pages.find(({ id }) => id === value)}
      onChange={(opt, e) => {
        e.preventDefault()
        e.stopPropagation()
        onChange(opt.id)
      }}
      portalMenu={portal}
      //toggleClassName='dark:[&:not(:hover)]:bg-slate-800!'
      menuFullWidth={!portal}
      menuZIndex='z-20'
      menuContainerClassName={!portal ? '' : 'mk-ag-sdd'}
      options={[{ id: '', title: 'Select Page' }, ...options]}
      optionLabel={(opt) => `${opt?.id} ${opt?.title}`}
      renderOption={(opt) => {
        return (
          <div className='flex-c'>
            <Screen24 width={16} height={16} />
            <div>{opt?.id === '' ? <Trans>{opt?.title}</Trans> : opt?.title}</div>
          </div>
        )
      }}
    />
  )
}
